// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 796 ? "public-legal" : chunkId) + "." + {"281":"e8ff5037","796":"e3c547b4"}[chunkId] + ".chunk.css";
};